import { Auth } from "aws-amplify";
import { Module } from "vuex";
import { IActions, IGetters, IMutations, ISaleState } from "./sale.type";

export const getters: IGetters = {
    getId: (state) => {
        return state.sale?.id;
    },
    name: (state) => {
        return state.sale?.firstname;
    }
};

export const mutations: IMutations = {
    setLoading: (state, payload) => {
        state.loading = payload;
    },
    setSale: (state, payload) => {
        state.sale = payload;
    },
    setCustomers: (state, payload) => {
        state.customers = payload;
    },
};

export const actions: IActions = {
    async fetchSale(this, context, payload): Promise<void> {
        const u = await this.$services.sales.getSaleById(payload);
        context.commit("setUser", u?.data());
    },
    async syncSale(this, context, payload): Promise<void> {
        console.log("syncSale:", payload);
        try {
            context.commit("setLoading", true);
            const u = await this.$services.sales.syncSale(payload);
            context.commit("setSale", u.data());
            console.log(u.customerList());
            context.commit("setCustomers", u.customerList());
        } catch (error) {
            console.warn(error);
        } finally {
            context.commit("setLoading", false);
        }
    },
    async updateSale(this, context, payload): Promise<void> {
        console.log("updateSale:", payload);
        try {
            context.commit("setLoading", true);
            const u = await this.$services.sales.updateSale(payload);
            context.commit("setSale", u.data());
        } catch (error) {
            console.warn(error);
        } finally {
            context.commit("setLoading", false);
        }
    },
    async addNewCustomer(this, context, payload): Promise<void> {
        console.log("addNewCustomer", payload);
        const c = await this.$services.customers.createCustomer(
            payload,
            context.state.sale!.id!
        );

        console.log("new customer: ", c);
        
        // TODO update customer
        c.basketID = c.id;
        const nc = await this.$services.customers.updateCustomer(
            c.data()
        )

        const list = [...context.state.customers, nc];
        context.commit("setCustomers", list);
    },
    async addExistingCustomer(this, context, payload): Promise<void> {
        console.log("addExistingCustomer", payload);
        
        // prevent duplicate
        const list = context.state.customers;
        const found:boolean = list.some((p) => p.id === payload.customerID);
        if(found){
            throw Error("Customer already exist in your customer list");
        }

        await this.$services.customers.addExistingCustomer(
            payload.customerID,
            context.state.sale!.id!
        );
    },
    async updateCustomer(this, context, payload): Promise<void> {
        console.log("sale -> updateCustomer", payload);
        const result = await this.$services.customers.updateCustomer(payload);
        const user = await Auth.currentAuthenticatedUser();
        const u = {
            id: user.attributes.sub,
            branch: user.attributes["custom:branch"],
            firstname: user.attributes["custom:firstname"],
            lastname: user.attributes["custom:lastname"],
        };
        context.dispatch("syncSale", u);
    },
    async updateCustomerAddress(this, context, payload): Promise<void> {
        console.log("sale -> updateCustomerAddress", payload);
        const result = await this.$services.customers.updateCustomerAddress(payload);
        const user = await Auth.currentAuthenticatedUser();
        const u = {
            id: user.attributes.sub,
            branch: user.attributes["custom:branch"],
            firstname: user.attributes["custom:firstname"],
            lastname: user.attributes["custom:lastname"],
        };
        context.dispatch("syncSale", u);
    }
};

const sale: Module<ISaleState, ISaleState> = {
    namespaced: true,
    state: {
        loading: true,
        sale: undefined,
        customers: [],
    },
    getters,
    mutations,
    actions,
};

export default sale;
